<template>
    <div ref="adminTabItems" class="tab-items row mt-4 mx-0">
        <div class="divider sm"></div>

        <!-- Menu -->
        <div class="col-2 col-lg-4 col-xl-3 p-0 mw-400">
            <div class="d-flex flex-column w-100">
                <div class="flex-grow p-0">
                    <ul class="navbar-nav" role="tablist">
                        <template v-for="(settingsItem, index) in settingsItems">
                            <li class="nav-item pe-3 m-block-n1" role="presentation" v-ripple>
                                <a class="dropdown-item p-0 d-flex align-items-center cursor-pointer"
                                    :class="index == 0 ? 'active' : ''" data-bs-toggle="tab"
                                    :data-bs-target="`#setting-${index}`" role="tab" type="button"
                                    @click="currentTab = settingsItem.label">
                                    <i class="ps-0"
                                        :class="[settingsItem.iconClass, { 'me-3': width > 992, 'mx-auto': width <= 992 }]"></i>
                                    <template v-if="width > 992">
                                        {{ settingsItem.label }}
                                        <i class="ms-auto px-0 ms-auto w-auto move-right"
                                            :class="settingsItem.iconRightClass"></i>
                                    </template>
                                </a>
                            </li>
                            <li class="nav-item pe-3">
                                <hr class="dropdown-divider">
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
        <!-- Content -->
        <div class="col-10 col-lg-8 col-xl-9 border-start ps-3 pb-3 pt-0 pe-0 min-vh-100 flex-grow-1">
            <div class="tab-content" id="nav-tabContent">
                <template v-for="(settingsItem, index) in settingsItems" :key="'company_tab_'+index">
                    <SingleCompanyTab v-if="currentTab == settingsItem.label" :title="settingsItem.label" :index="index"
                        :slug="settingsItem.slug"></SingleCompanyTab>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useWindowSize } from "@vueuse/core";
import SingleCompanyTab from '@/components/Admin/SingleCompanyTab.vue';
import { useAppHelpers } from '@/composables/useAppHelpers';

const helper = useAppHelpers();
const { width } = useWindowSize();

const currentTab = ref("About");
const adminTabItems = ref(null);

const settingsItems = [
    {
        iconClass: 'bi-buildings',
        label: 'About',
        iconRightClass: 'bi-chevron-right ms-auto',
        slug: 'about'
    },
    {
        iconClass: 'bi-file-check',
        label: 'Terms and Conditions',
        iconRightClass: 'bi-chevron-right ms-auto',
        slug: 'terms_and_conditions'
    },
    {
        iconClass: 'bi-shield-check',
        label: 'Privacy Policy',
        iconRightClass: 'bi-chevron-right ms-auto',
        slug: 'privacy_policy'
    },
    {
        iconClass: 'bi-cookie',
        label: 'Cookie Policy',
        iconRightClass: 'bi-chevron-right ms-auto',
        slug: 'cookie_policy'
    },
    {
        iconClass: 'bi-database-lock',
        label: 'Data Subject Policy',
        iconRightClass: 'bi-chevron-right ms-auto',
        slug: 'data_subject_policy'
    },
];



</script>


<style scoped lang="scss">
.dropdown-divider {
    margin: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.175);
}

.dropdown-item {
    &:not(.p-big) {
        padding-bottom: 0.7em !important;
        padding-top: 0.7em !important;
    }

    &:hover {
        background-color: transparent !important;

        .move-right {
            transform: translateX(5px);
        }
    }

    .move-right {
        transition: transform 0.3s linear;
    }
}

.mw-400 {
    max-width: 400px;
}

.nav-item.ripple {
    @media (min-width: 768px) {
        margin-left: -24px;
        padding-left: 24px;
    }

    @media (min-width: 1399px) {
        margin-left: -32px;
        padding-left: 32px;
    }
}

.tab-pane {
    :deep(.ql-editor) {
        min-height: 100vh;
    }
}
</style>